import { render, staticRenderFns } from "./formGroup.vue?vue&type=template&id=6e6ff165"
import script from "./formGroup.vue?vue&type=script&lang=js"
export * from "./formGroup.vue?vue&type=script&lang=js"
import style0 from "./formGroup.vue?vue&type=style&index=0&id=6e6ff165&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports